export default __webpack_public_path__ + "static/media/project_medmex_1.66631569.png";